import * as Sentry from '@sentry/react';

const initSentry = () =>
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: process.env.REACT_APP_ENV,
  });

export { initSentry };
